export function getMonthDays(year: number, month: number): Date[] {
  const lastDay = new Date(year, month + 1, 0)
  const days: Date[] = []

  for (let date = 1; date <= lastDay.getDate(); date++) {
    const day = new Date(Date.UTC(year, month, date))
    // Only include weekdays (Mon-Fri)
    const dayOfWeek = day.getUTCDay()
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      days.push(day)
    }
  }

  return days
}

export function formatDate(date: Date): string {
  const year = date.getUTCFullYear()
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
  const day = date.getUTCDate().toString().padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatDisplayDate(date: Date): string {
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  })
}

export function getMonthName(month: number): string {
  return new Date(2024, month, 1).toLocaleDateString("en-US", { month: "long" })
}

/**
 * Checks if a date is today (ignoring time)
 */
export function isToday(date: Date): boolean {
  const today = new Date()
  return (
    date.getUTCFullYear() === today.getFullYear() &&
    date.getUTCMonth() === today.getMonth() &&
    date.getUTCDate() === today.getDate()
  )
}

/**
 * Groups weekdays into weeks, with proper alignment to Mon-Fri columns
 * Each week is an array of 5 elements (Mon-Fri), with null for days outside the month
 * 
 * @param days - Array of Date objects (weekdays only)
 * @returns Array of weeks, where each week is an array of 5 dates (or null for empty cells)
 */
export function groupDaysByWeek(days: Date[]): (Date | null)[][] {
  if (days.length === 0) return []
  
  const weeks: (Date | null)[][] = []
  let currentWeek: (Date | null)[] = [null, null, null, null, null] // Mon, Tue, Wed, Thu, Fri
  
  days.forEach((day) => {
    const dayOfWeek = day.getUTCDay() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    
    // Convert to our index: Mon=0, Tue=1, Wed=2, Thu=3, Fri=4
    const weekIndex = dayOfWeek - 1 // Monday = 0, Tuesday = 1, etc.
    
    // If we encounter a Monday and current week has any content, start a new week
    if (weekIndex === 0 && currentWeek.some(d => d !== null)) {
      weeks.push(currentWeek)
      currentWeek = [null, null, null, null, null]
    }
    
    // Place the day in the correct position
    currentWeek[weekIndex] = day
  })
  
  // Push the last week if it has any content
  if (currentWeek.some(d => d !== null)) {
    weeks.push(currentWeek)
  }
  
  return weeks
}
